import create from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
export const useModalStore = create()(devtools(immer((set) => ({
    isOpen: false,
    open: ({ title, content, extraClass = '' }) => {
        set((state) => {
            state.title = title;
            state.content = content;
            state.isOpen = true;
            state.extraClass = extraClass;
        });
    },
    close: () => {
        set((state) => {
            state.title = undefined;
            state.content = undefined;
            state.isOpen = false;
            state.extraClass = '';
        });
    },
}))));
